import React from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';

function StoryThumbnail({ story, onClick }) {
  const { title, tags } = story;

  return (
    <motion.div 
      className="bg-[#FFF3DD] rounded-3xl p-6 text-[#343434] cursor-pointer hover:shadow-[0_8px_30px_rgb(0,0,0,0.12)] transition-shadow duration-300"
      onClick={onClick}
      layout
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="flex justify-between items-start mb-4">
        <h3 className="font-freeman text-2xl text-[#343434] leading-[110%] tracking-[-0.03rem] flex-1 pr-4">{title}</h3>
        <button 
          className="w-10 h-10 bg-[#7785FC] text-white rounded-full flex items-center justify-center hover:bg-[#6674eb] transition-colors flex-shrink-0"
          onClick={(e) => {
            e.stopPropagation();
            // Add your play functionality here
          }}
        >
          <Play size={20} className="fill-current" />
        </button>
      </div>
      <div className="flex flex-wrap gap-2">
        {tags.map((tag, index) => (
          <span 
            key={index}
            className="bg-[#ffffff] text-[#343434] px-2.5 py-1.5 rounded-full font-['Aleo'] text-[0.75rem] font-medium leading-none tracking-[-0.00875rem] flex items-center"
          >
            <span className="translate-y-[0.5px]">{tag}</span>
          </span>
        ))}
      </div>
    </motion.div>
  );
}

export default StoryThumbnail; 